import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// List route
export const globalIncomingCallRoute: InvariantJiraRoute = {
	name: 'eoc-incoming-call',
	path: '/jira/settings/products/ops/incoming-call',
	exact: true,
};
